var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.flag},[_c('button',{staticClass:"btn btn-tabmenu",attrs:{"type":"button","data-target":_vm.getTabIndex},on:{"click":_vm.clickTabmenu}},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.item.menu_disp_nm)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }